import { Controller } from '@hotwired/stimulus'

// Handles bulk form submission with selected IDs.
// Listens for "selection:change" events to enable/disable and populate form.
// Supports "select all" mode for bulk operations on all query results.
export default class extends Controller {
  static targets = ['submit']
  static values = {
    ids: { type: Array, default: [] },
    selectAll: { type: Boolean, default: false },
  }

  selectionChanged({ detail: { ids } }) {
    this.idsValue = ids
    this.#updateSubmitButton()
  }

  selectAllChanged({ detail: { selectAll } }) {
    this.selectAllValue = selectAll
    this.#updateSubmitButton()
  }

  submit(event) {
    event.preventDefault()
    this.#populateHiddenFields()
    this.element.requestSubmit()
  }

  // Private

  #updateSubmitButton() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled =
      this.idsValue.length === 0 && !this.selectAllValue
  }

  #populateHiddenFields() {
    this.#clearHiddenFields()

    if (this.selectAllValue) {
      this.#appendHiddenField('select_all', 'true')
    } else {
      this.idsValue.forEach((id) => {
        this.#appendHiddenField('block_ids[]', id)
      })
    }
  }

  #clearHiddenFields() {
    this.element
      .querySelectorAll('input[name="select_all"], input[name="block_ids[]"]')
      .forEach((el) => el.remove())
  }

  #appendHiddenField(name, value) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    this.element.appendChild(input)
  }
}
